import React, { HTMLAttributes } from 'react';
import { StyledControlPanelContainer } from './VideoCallControlPanel.style';

type VideoCallControlPanelPropsType = HTMLAttributes<HTMLDivElement>;

const VideoCallControlPanel: React.FC<VideoCallControlPanelPropsType> = ({ children, ...props }) => {
  return <StyledControlPanelContainer {...props}>{children}</StyledControlPanelContainer>;
};

export default React.memo(VideoCallControlPanel);
